/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cards[_ngcontent-%COMP%]{height:1px}.cards__loading[_ngcontent-%COMP%]{display:flex;justify-content:center;margin-top:20vh}.cards__content[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));grid-auto-rows:minmax(220px,auto);grid-auto-flow:row;grid-gap:32px}"];
export { styles as styles };
